export const pageview = (path) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title
  });
};

export const gaEvent = (action, params = {}) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', action, params);
};
